/**
 * Service for managing LiveKit rooms
 */
import { getCookie } from '../api/cookie';
import { logger } from '../utils/logger';

const API_BASE_URL = 'https://api.frontdesk24.com/api';

/**
 * Deletes a LiveKit room
 */
export async function deleteRoom(roomName: string): Promise<void> {
  if (!roomName) {
    logger.warn('No room name provided for deletion');
    return;
  }

  try {
    const token = getCookie('token') || '';
    const deleteRoomApiUrl = `${API_BASE_URL}/delete-livekit-room`;

    const response = await fetch(deleteRoomApiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ roomName }),
    });

    if (!response.ok) {
      throw new Error(`Failed to delete room: ${response.status}`);
    }

    await response.json();
  } catch (error) {
    logger.error('Error deleting room:', error);
    // Don't throw - continue with disconnect even if deletion fails
  }
}
